var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"company-search-input section-header-left user-requests-search"},[_c('input',{attrs:{"placeholder":_vm.placeholder,"autocomplete":"off","type":"search"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }